export default __webpack_public_path__ + "static/media/editWithAlert.b451eff2.svg";